import { portals, type Portal } from '@tmr/login-kit';

/**
 * Camada ISOLADA do Portal do Administrador.
 * Herda a definição compartilhada e permite override local SEM afetar os
 * outros portais. Edite à vontade aqui.
 */
export const portal: Portal = {
  ...portals.admin,
  // Exemplos de override local:
  // secure: true,
  // footnote: 'Verificação em duas etapas obrigatória',
};
